import React from "react";
import { useTranslation } from "react-i18next";
import CalendarDaysIcon from "../icons/heroicons/solid/CalendarDays";
import promotionIcon from "../../assets/images/promotion-icon.png";

const SectionHeader = ({
  name = "",
  eventSection = false,
  seniorLayout = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center gap-2 font-semibold py-4  whitespace-nowrap">
      <img
        src={promotionIcon}
        alt="promotion"
        className="object-contain w-6 h-6"
        loading="lazy"
        decoding="async"
      />
      <span className={`text-${seniorLayout ? "2xl" : "base"}`}>
        {t(name)}
      </span>
    </div>
  );
};

export default SectionHeader;
